export default {
  products: null,
  _product: null,
  homeProducts: null,
  search: null,
  searchConfig: {},
  selectedVariant: null
}
